import { Injectable } from '@angular/core';
import {HttpService, QueryModel} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {DoctorSettingsModel} from '../../models/doctor-settings/doctor-settings.model';
import {DoctorCreateModel, DoctorModel} from '../../models/doctor/doctor.model';
import {ReservedAppointmentModel, ReservedAppointmentsModel} from '../../models/appointment/appointment.model';

@Injectable({
  providedIn: 'root'
})
export class DoctorService extends HttpService {

    getDoctors(queryModel?: QueryModel): Observable<iResponseList<DoctorModel>> {
        return this.get('doctors', queryModel).pipe(
            map((response: iResponseList<DoctorModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    undeleteDoctor(doctorId: string): Observable<any> {
        return this.patch(`doctors/${doctorId}/undelete`, {}).pipe(
            map((response: any) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }
    getDoctorSettings(doctorId: string): Observable<iResponse<DoctorSettingsModel>> {
        return this.get(`doctors/${doctorId}/settings`).pipe(
            map((response: iResponse<DoctorSettingsModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    saveDoctorSettings(doctorId: string, settings: DoctorSettingsModel): Observable<any> {
        return this.put(`doctors/${doctorId}/settings/${settings.id}`, settings).pipe(
            map((response: any) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    getMyProfile(): Observable<any> {
        return this.get('doctors/me').pipe(
            map((response: iResponse<any>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    getDoctorsForPractice(practiceId: string): Observable<iResponseList<DoctorModel>> {
        return this.get(`doctors/practice/${practiceId}`).pipe(
            map((response: iResponseList<DoctorModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    getAppointmentsForDoctor(doctorId: string, query: QueryModel): Observable<iResponseList<ReservedAppointmentModel>> {
        return this.get(`doctors/${doctorId}/appointments`, query).pipe(
            map((response: iResponseList<ReservedAppointmentModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    confirmAppointment(doctorId: string, appointmentId: string): Observable<any> {
        return this.put(`doctors/${doctorId}/appointments/${appointmentId}/confirm`, {}).pipe(
            map((response: any) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    createDoctor(doctor: DoctorCreateModel): Observable<iResponse<DoctorModel>> {
        return this.post('doctors', doctor).pipe(
            map((response: iResponse<DoctorModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    updateDoctor(doctor: DoctorCreateModel, doctorId: string): Observable<iResponse<DoctorModel>> {
        return this.put(`doctors/${doctorId}`, doctor).pipe(
            map((response: iResponse<DoctorModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    deleteDoctor(doctorId: string): Observable<iResponse<boolean>> {
        return this.delete(`doctors/${doctorId}`).pipe(
            map((response: iResponse<boolean>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    cancelAppointment(doctorId: string, appointmentId: string, reason: string): Observable<any> {
        return this.put(`doctors/${doctorId}/appointments/${appointmentId}/cancel`, {reason: reason}).pipe(
            map((response: any) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }
}
